export default {
  CLEAR_BLOCKS_HTML: '@WS/CLEAR_BLOCKS_HTML',
  CLEAR_PAGE_TEMPLATES_HTML: '@WS/CLEAR_PAGE_TEMPLATES_HTML',
  CLEAR_GLOBALS_HTML: '@WS/CLEAR_GLOBALS_HTML',
  SET_MAIN_LOCALE: '@WS/SET_MAIN_LOCALE',
  ADD_LOCALE: '@WS/ADD_LOCALE',
  REMOVE_LOCALE: '@WS/REMOVE_LOCALE',
  SAVE_MAIN_LOCALE: '@WS/SAVE_MAIN_LOCALE',
  SET_SUPPORTED_LOCALES: '@WS/SET_SUPPORTED_LOCALES',
};
